import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { useSelector } from 'react-redux';
import { MdExpandLess, MdExpandMore } from 'react-icons/md';
import { Collapse, List, ListItemButton, ListItemText } from '@mui/material';

import { useStyles } from '../../styles';
import { Each } from 'GeminiViewerComponent/helpers/Each';
import { selectActiveTheme } from 'GeminiViewerComponent/features/globals/themeSlice';
import { getCurrentNode } from '../../features/procedureSlice';

const NavigationLink = ({ currentNode, categoryIdx, navigationLinks, onNodeClick }) => {
    return navigationLinks && navigationLinks.length > 0 ? (
        <Each
            of={navigationLinks}
            render={(node, idx) => (
                <ListItemButton
                    id={`viewer_procedure_nav-category-${categoryIdx}_node-${idx}`}
                    data-node-id={node.id}
                    className={clsx([
                        'navigationLinkButton',
                        node.id === currentNode.id ? 'activeNavigationLink' : 'navigationPanel',
                    ])}
                    sx={{ pl: 4 }}
                    onClick={() => onNodeClick(node)}
                >
                    <ListItemText primary={node.title || '-'} />
                </ListItemButton>
            )}
        />
    ) : (
        <ListItemButton className={clsx(['navigationLinkButton', 'navigationPanel'])} disabled sx={{ pl: 4 }}>
            <ListItemText primary="No Node" />
        </ListItemButton>
    );
};

const NoneCategory = ({ open, currentNode, categoryIdx, handleClick, navigationLinks, onNodeClick }) => {
    const theme = useSelector(selectActiveTheme);
    const classes = useStyles(theme);

    return (
        navigationLinks.filter((link) => !link?.node_category).length > 0 && (
            <List component="div" disablePadding>
                <ListItemButton
                    id={`viewer_procedure_no_nav-category_node-${categoryIdx}`}
                    data-node-id={currentNode?.id}
                    className={classes.categoryButton}
                    onClick={() => handleClick(0)}
                >
                    <ListItemText
                        sx={{
                            '& span': {
                                fontWeight: 'bold',
                            },
                        }}
                        primary="NONE"
                    />
                    {open[0] ? <MdExpandLess /> : <MdExpandMore />}
                </ListItemButton>
                <Collapse sx={{ marginLeft: '10px' }} in={open[0]} timeout="auto" unmountOnExit>
                    <NavigationLink
                        currentNode={currentNode}
                        navigationLinks={navigationLinks.filter((link) => !link?.node_category)}
                        categoryIdx={categoryIdx}
                        onNodeClick={onNodeClick}
                    />
                </Collapse>
            </List>
        )
    );
};

const NodeCategoryPanel = ({ navigationLinks, procedureCategories, onNodeClick }) => {
    const currentNode = useSelector(getCurrentNode);
    const theme = useSelector(selectActiveTheme);
    const classes = useStyles(theme);

    const [open, setOpen] = useState(new Array(procedureCategories?.length).fill(false));

    const handleClick = async (index) => {
        let accordian = [...open];
        accordian[index] = !accordian[index];
        setOpen(accordian);
    };

    useEffect(() => {
        let accordian = new Array(procedureCategories?.length).fill(false);
        if (currentNode?.node_category?.id) {
            accordian[currentNode?.node_category?.id] = !accordian[currentNode?.node_category?.id];
        } else {
            accordian[0] = !accordian[0];
        }
        setOpen(accordian);
    }, [currentNode]);

    const anyNodesWithoutCategories = navigationLinks.find((link) => !link?.node_category);

    let index = 0;

    return (
        <>
            <Each
                of={procedureCategories}
                render={(category) =>
                    navigationLinks.filter((link) => link?.node_category?.id === category.id).length > 0 && (
                        <List component="div" disablePadding>
                            <ListItemButton
                                id={`viewer_procedure_nav-category_category-${index}`}
                                data-category-id={category?.id}
                                className={classes.categoryButton}
                                onClick={() => handleClick(category?.id)}
                                tabIndex={category?.id}
                            >
                                <ListItemText
                                    sx={{
                                        '& span': {
                                            fontWeight: 'bold',
                                        },
                                    }}
                                    primary={category?.name}
                                />
                                {open[category?.id] ? <MdExpandLess /> : <MdExpandMore />}
                            </ListItemButton>
                            <Collapse in={open[category?.id]} timeout="auto" sx={{ marginLeft: '10px' }} unmountOnExit>
                                <NavigationLink
                                    currentNode={currentNode}
                                    categoryIdx={index++}
                                    navigationLinks={navigationLinks.filter(
                                        (link) => link?.node_category?.id === category.id
                                    )}
                                    onNodeClick={onNodeClick}
                                />
                            </Collapse>
                        </List>
                    )
                }
            />
            {anyNodesWithoutCategories && (
                <NoneCategory
                    open={open}
                    currentNode={currentNode}
                    handleClick={handleClick}
                    categoryIdx={index}
                    navigationLinks={navigationLinks}
                    onNodeClick={onNodeClick}
                />
            )}
        </>
    );
};

export { NodeCategoryPanel };
